export interface SelectionState {
    selectedIds: Set<number>;
    isSelectAllOnPage: boolean;
}
// Define thresholds for selection tiers to guide user experience during bulk operations
export const TIER_THRESHOLDS = {
    DIRECT: 24,
    WARNING: 59,
    MANDATORY_REVIEW: 200,
} as const;

export type SelectionTier = 'direct' | 'warning' | 'mandatory-review' | 'hard-block';

export const getSelectionTier = (count: number): SelectionTier => {
    if (count <= TIER_THRESHOLDS.DIRECT) return 'direct';
    if (count <= TIER_THRESHOLDS.WARNING) return 'warning';
    if (count <= TIER_THRESHOLDS.MANDATORY_REVIEW) return 'mandatory-review';
    return 'hard-block';
};

export const toggleId = (ids: Set<number>, id: number): Set<number> => {
    const next = new Set(ids);
    if (next.has(id)) {
        next.delete(id);
    } else {
        next.add(id);
    }
    return next;
};

export const selectAllIds = (ids: Set<number>, newIds: number[]): Set<number> => {
    const next = new Set(ids);
    newIds.forEach(id => next.add(id));
    return next;
};

export const deselectAllIds = (ids: Set<number>, removeIds: number[]): Set<number> => {
    const next = new Set(ids);
    removeIds.forEach(id => next.delete(id));
    return next;
};

export const allOnPageSelected = (selectedIds: Set<number>, pageIds: number[]): boolean =>
    pageIds.length > 0 && pageIds.every(id => selectedIds.has(id));
